import { motion } from 'framer-motion';
import { Zap, Plus, AlertTriangle, Sparkles } from 'lucide-react';

interface QuickActionsProps {
    onAction: (action: string) => void;
    overdueCount: number;
}

export function QuickActions({ onAction, overdueCount }: QuickActionsProps) {
    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8 }}
            className="mb-6"
        >
            <h3 className="text-lg font-semibold text-gray-900 mb-3 flex items-center">
                <Zap className="h-5 w-5 mr-2 text-blue-600" />
                Quick Actions
            </h3>
            <div className="grid grid-cols-3 gap-3">
                <motion.button
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    onClick={() => onAction('add-entry')}
                    className="bg-gradient-to-r from-green-500 to-emerald-600 text-white p-4 rounded-xl shadow-sm hover:shadow-md transition-all"
                >
                    <Plus className="h-6 w-6 mx-auto mb-2" />
                    <span className="text-sm font-medium">Add Entry</span>
                </motion.button>

                <motion.button
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    onClick={() => onAction('check-overdue')}
                    disabled={overdueCount === 0}
                    className={`p-4 rounded-xl shadow-sm transition-all ${overdueCount > 0
                        ? 'bg-gradient-to-r from-orange-500 to-red-600 text-white hover:shadow-md'
                        : 'bg-gray-100 text-gray-400 cursor-not-allowed'
                        }`}
                >
                    <AlertTriangle className="h-6 w-6 mx-auto mb-2" />
                    <span className="text-sm font-medium">Check Overdue</span>
                </motion.button>

                <motion.button
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    onClick={() => onAction('voice-assistant')}
                    className="bg-gradient-to-r from-purple-500 to-pink-600 text-white p-4 rounded-xl shadow-sm hover:shadow-md transition-all"
                >
                    <Sparkles className="h-6 w-6 mx-auto mb-2" />
                    <span className="text-sm font-medium">X-Assist</span>
                </motion.button>
            </div>
        </motion.div>
    );
}
